import { all } from 'redux-saga/effects';
import { takeLoginRequest, takeVcodeRequest, changePwd, logout, getBaseUrlRequest } from './login/login';
import { getListRequest, getStatusDictRequest, handleBatchRequest, setInitFormListener, getMediationSessionRequest, postMediationBatchRequest } from './casepool';
import { postSignatureRequest } from './signature'
import { getMemberRequest, findClosedReasonRequest } from './global';
import {
    getDetailRequest,
    closingRegtRequest,
    setMediationParamRequest,
    postDetailSubmitRequest,
    pdfConversionRequest,
    checkResRequest,
    deleteFileRequest,
    getLostPhoneRequest,
    downloadEleRequest,
    submitRepaymentRequest,
    getPhoneNumberRequest,
    mediationTimeRequest,
    mediationRegisterRequest,
    mediationRegisterUpdateRequest,
    callDefendantRequest,
    sendMsgRequest,
    getMediationDocRequest,
    sendMediationDocRequest,
    dzjzUploadRequest,
    getSignatureRequest,
    sendFlashLetterRequest,
    postAutomaticSubmitRequest,
    getCallTypeRequest, postPaymentRequest, postPaymentSubmitUpdateRequest, getLostProviderTypeDictRequest
} from './caseDetail';


import { startMeetingRequest } from './caseDetail/meeting';
export default function* rootSaga() {
    yield all([
        takeLoginRequest(),
        takeVcodeRequest(),
        changePwd(),
        logout(),
        // 获取列表数据
        getListRequest(),
        // 案件列表
        getStatusDictRequest(),
        // 获取详情
        getDetailRequest(),
        // 批量操作
        handleBatchRequest(),
        // 人员列表
        getMemberRequest(),
        // 结案登记获取关闭原因
        findClosedReasonRequest(),
        // 结案登记
        closingRegtRequest(),
        //更新调解状态参数
        setMediationParamRequest(),

        postDetailSubmitRequest(),
        pdfConversionRequest(),
        checkResRequest(),
        deleteFileRequest(),
        downloadEleRequest(),
        // 开始 庭审/在线调解
        startMeetingRequest(),
        // 协查找人获取
        getLostPhoneRequest(),
        // 申请协商还款
        submitRepaymentRequest(),
        //获取电话号码
        getPhoneNumberRequest(),
        //获取在线调解时间
        mediationTimeRequest(),

        //新增调解登记
        mediationRegisterRequest(),
        // 调解登记修改
        mediationRegisterUpdateRequest(),
        // 拨打电话
        callDefendantRequest(),
        //发送闪信
        sendFlashLetterRequest(),
        //发短信
        sendMsgRequest(),

        getMediationDocRequest(),

        sendMediationDocRequest(),
        // 保存form表单值
        setInitFormListener(),
        getMediationSessionRequest(),
        postMediationBatchRequest(),
        dzjzUploadRequest(),
        getSignatureRequest(),
        getBaseUrlRequest(),
        postSignatureRequest(),
        postAutomaticSubmitRequest(),
        getCallTypeRequest(),
        postPaymentRequest(),
        postPaymentSubmitUpdateRequest(),
        getLostProviderTypeDictRequest()
    ])
}
